import { Dispatch, createSlice } from '@reduxjs/toolkit';
import { API_URL } from '../constants';
import { setShowError } from './error';
import { setShowLoader } from './loader';

export interface NumberInfoProps {
  phone_number: string;
  country: string;
  region: string;
  carrier: string;
  timezone: string;
  type: string;
  latitude?: number | null;
  longitude?: number | null;
}

export const mapSlice = createSlice({
  name: 'map',
  initialState: {
    numberData: {},
  },
  reducers: {
    setNumberData: (state, action) => {
      state.numberData = action.payload;
    },
  },
});

export const fetchNumberData = (number: string) => async (dispatch: Dispatch) => {
  try {
    const response = await fetch(`${API_URL}/phone-number-info/${number}`);
    const data = await response.json();

    if (response.status === 200) {
      dispatch(setNumberData(data.data));
    } else {
      dispatch(setShowError('Phone number is incorrect'));
    }

    return response.status;
  } catch (error: any) {
    dispatch(setShowError(error.message || 'An error occurred, please try again'));
    return error instanceof TypeError ? 400 : 500;
  } finally {
    dispatch(setShowLoader(false));
  }
};

export const calculateOffset = (lat: number, lng: number) => {
  const rEarth = 6371000.0;
  const dy = 3000;
  const dx = 3000;

  const newLat = lat + (dy / rEarth) * (180 / Math.PI);
  const newLng = lng + (dx / rEarth) * (180 / Math.PI);

  return {
    newLat,
    newLng,
  };
};

export const { setNumberData } = mapSlice.actions;

export const selectNumberData = (state: any) => state.map.numberData;

export default mapSlice.reducer;
